export default __webpack_public_path__ + "static/media/Witbooker_ES.856ef6a9.png";